import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HtmlMapper = _resolveComponent("HtmlMapper", true)
  const _component_CollapsedMdTable = _resolveComponent("CollapsedMdTable")
  const _component_Button = _resolveComponent("Button")
  const _component_ExternalLink = _resolveComponent("ExternalLink")
  const _component_SourcesInline = _resolveComponent("SourcesInline")
  const _component_Widgets = _resolveComponent("Widgets")
  const _component_ApolloLink = _resolveComponent("ApolloLink")

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.processed_nodes, (node, idx) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
      (node.type === 'table')
        ? (_openBlock(), _createBlock(_component_CollapsedMdTable, { key: 0 }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_HtmlMapper, {
                restricted: $props.restricted,
                nodes: node.content
              }, null, 8 /* PROPS */, ["restricted", "nodes"])
            ]),
            _: 2 /* DYNAMIC */
          }, [
            (node.title)
              ? {
                  name: "title",
                  fn: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(node.title.name), _mergeProps({ ref_for: true }, node.attributes, {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_HtmlMapper, {
                          restricted: $props.restricted,
                          nodes: node.title.content
                        }, null, 8 /* PROPS */, ["restricted", "nodes"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024 /* DYNAMIC_SLOTS */))
        : (node.type === 'button')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              disabled: $props.restricted,
              tiny: "",
              onClick: $event => (_ctx.$dispatch('inline-button', node.click))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(node.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"]))
          : (node.type === 'mailto-link')
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: node.href,
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, _toDisplayString(node.text), 9 /* TEXT, PROPS */, _hoisted_1))
            : (node.type === 'external-link')
              ? (_openBlock(), _createBlock(_component_ExternalLink, {
                  key: 3,
                  href: node.href
                }, null, 8 /* PROPS */, ["href"]))
              : (node.type === 'sources')
                ? (_openBlock(), _createBlock(_component_SourcesInline, {
                    key: 4,
                    text: node.text,
                    href: node.href,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8 /* PROPS */, ["text", "href"]))
                : (node.type === 'widgets')
                  ? (_openBlock(), _createBlock(_component_Widgets, {
                      key: 5,
                      href: node.href
                    }, null, 8 /* PROPS */, ["href"]))
                  : (node.type === 'apollo-link')
                    ? (_openBlock(), _createBlock(_component_ApolloLink, {
                        key: 6,
                        text: node.text,
                        href: node.href,
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8 /* PROPS */, ["text", "href"]))
                    : (node.type === 'parent')
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(node.name), _mergeProps({
                          key: 7,
                          ref_for: true
                        }, node.attributes, {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_HtmlMapper, {
                              restricted: $props.restricted,
                              nodes: node.content
                            }, null, 8 /* PROPS */, ["restricted", "nodes"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                      : (!!node.name)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(node.name), _mergeProps({
                            key: 8,
                            ref_for: true
                          }, node.attributes, {
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                          }), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(node.content), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            _createTextVNode(_toDisplayString(node.content), 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
    ], 64 /* STABLE_FRAGMENT */))
  }), 128 /* KEYED_FRAGMENT */))
}